import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';

export default {
    components: { ahElSelectBankAccount },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        rules: {
            type: Object,
            default: () => {},
        },
        updateAmts: {
            type: Function,
            default: () => {},
        },
        onChangeDate: {
            type: Function,
            default: () => {},
        },
        onChangeBank: {
            type: Function,
            default: () => {},
        },
    },
    methods: {
        onInput(value, field) {
            this.$emit('input', { value, field, name: this.name });
        },
    },
};
